var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70678 1.05337L15.0001 11.3467L25.2401 1.10671C25.4663 0.865954 25.7388 0.67336 26.0412 0.540473C26.3436 0.407587 26.6698 0.337146 27.0001 0.333374C27.7074 0.333374 28.3856 0.614325 28.8857 1.11442C29.3858 1.61452 29.6668 2.2928 29.6668 3.00004C29.673 3.32698 29.6123 3.65174 29.4885 3.95439C29.3647 4.25704 29.1804 4.5312 28.9468 4.76004L18.5734 15L28.9468 25.3734C29.3863 25.8034 29.644 26.3856 29.6668 27C29.6668 27.7073 29.3858 28.3856 28.8857 28.8857C28.3856 29.3858 27.7074 29.6667 27.0001 29.6667C26.6603 29.6808 26.3212 29.6241 26.0044 29.5001C25.6877 29.3762 25.4001 29.1877 25.1601 28.9467L15.0001 18.6534L4.73344 28.92C4.50812 29.1528 4.23895 29.3386 3.94145 29.4667C3.64395 29.5949 3.32401 29.6628 3.00011 29.6667C2.29286 29.6667 1.61459 29.3858 1.11449 28.8857C0.614393 28.3856 0.333442 27.7073 0.333442 27C0.327224 26.6731 0.387883 26.3483 0.511695 26.0457C0.635507 25.743 0.819861 25.4689 1.05344 25.24L11.4268 15L1.05344 4.62671C0.613935 4.19673 0.356214 3.61447 0.333442 3.00004C0.333442 2.2928 0.614393 1.61452 1.11449 1.11442C1.61459 0.614325 2.29286 0.333374 3.00011 0.333374C3.64011 0.341374 4.25344 0.600041 4.70678 1.05337Z",
    fill: "#5686C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.201bcef0822b8db58c80526647cf5b7d.svg";
export { ForwardRef as ReactComponent };